module.exports = __webpack_public_path__ + "static/mir-aminy-2-6a90d7da35bc3096059245471885d512.jpg";